import React from 'react';

const NewsComponent = ({ companyName, date, title }) => {
  return (
    <div
      style={{
        border: '1px solid #F0F0F0',
        margin: '.5rem auto',
        padding: '.7rem',
        display: 'flex',
        alignItems: 'center'
      }}>
      <div style={{ minWidth: '115px', fontSize: '21px', marginRight: '2rem' }}>
        <p>{companyName}</p>
      </div>
      <div>
        <p
          style={{ fontFamily: 'PT sans', fontSize: '14px', color: '#6D7278' }}>
          {date}
        </p>
        <h6
          style={{
            fontFamily: 'PT sans',
            fontSize: '16px',
            fontWeight: 'bold',
            color: '#252525'
          }}>
          {title}
        </h6>
      </div>
    </div>
  );
};

export default NewsComponent;
